module.exports = __webpack_public_path__ + "static/media/rewards_tournament_golden.cd233eb7.png";